import React from 'react';
import { useSelector } from 'react-redux';

import { orderedMiscellaneousMenteeModulesSelector } from 'features/moduleManagement';
import ErrorLayout from 'components/ErrorLayout';
import MiscellaneousMenteeModulesTableHeader from '../MiscellaneousMenteeModulesTableHeader';
import MiscellaneousMenteeModulesTableRow from '../MiscellaneousMenteeModulesTableRow';
import styles from './MiscellaneousMenteeModulesTable.module.scss';
import Table from 'components/Table';
import TableBody from 'components/TableBody';

function MiscellaneousMenteeModulesTable() {
  const orderedMenteeModules = useSelector(
    orderedMiscellaneousMenteeModulesSelector
  );

  if (orderedMenteeModules.length > 0) {
    return (
      <Table className={styles.table}>
        <MiscellaneousMenteeModulesTableHeader />
        <TableBody>
          {orderedMenteeModules.map((menteeModule) => (
            <MiscellaneousMenteeModulesTableRow
              menteeModule={menteeModule}
              key={menteeModule.id}
            />
          ))}
        </TableBody>
      </Table>
    );
  }

  return (
    <ErrorLayout message="This learner does not have any miscellaneous modules." />
  );
}

export default MiscellaneousMenteeModulesTable;
